import React, { FC, ReactNode } from 'react';
import { useStyles } from './styles';
import { Button, ListItemIcon, MenuItem } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { useMenu } from '../Menu';

export interface BrandMenuItem {
  id?: string;
  label: string;
  icon?: ReactNode;
  color?: string;
  selected?: boolean;
  disabled?: boolean;
}

interface BrandMenuProps {
  items: BrandMenuItem[];
  onItemSelect?: (item: BrandMenuItem) => void;
  defaultLabel?: string;
  dark?: boolean;
}

export const BrandMenu: FC<BrandMenuProps> = ({
  items,
  onItemSelect,
  defaultLabel,
  dark,
}) => {
  const classes = useStyles({ dark });
  const { openMenu, closeMenu } = useMenu();
  const selectedItem = items.find(({ selected }) => selected);

  return (
    <Button
      classes={{ root: classes.buttonRoot, text: classes.buttonLabel }}
      size="large"
      startIcon={
        selectedItem?.icon && (
          <div
            className={classes.buttonIcon}
            style={{
              color: selectedItem?.color,
              opacity: selectedItem?.color ? 0.7 : undefined,
            }}
          >
            {selectedItem?.icon}
          </div>
        )
      }
      endIcon={<ArrowDropDown fontSize="large" />}
      onClick={(e) => {
        openMenu(
          e.currentTarget,
          items.map((item, i) => (
            <MenuItem
              key={item.id || `menu-item-${i}`}
              classes={{ root: classes.menuItem }}
              style={{ color: item.color }}
              selected={item.selected}
              disabled={item.disabled}
              onClick={() => {
                closeMenu();
                onItemSelect && onItemSelect(item);
              }}
            >
              {item.icon && (
                <ListItemIcon
                  classes={{ root: classes.menuItemIcon }}
                  style={{
                    color: item.color,
                    opacity: item.color ? 0.7 : undefined,
                  }}
                >
                  {item.icon}
                </ListItemIcon>
              )}
              {item.label}
            </MenuItem>
          )),
        );
      }}
    >
      {selectedItem?.label ? (
        <span style={{ color: selectedItem?.color }}>
          {selectedItem?.label}
        </span>
      ) : (
        <span className={classes.defaultLabel}>{defaultLabel || '-'}</span>
      )}
    </Button>
  );
};
